// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WorkplanItem  {
    _originalTypeClassName = "Loom.BO.WorkplanItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WorkplanItem.translate = translateService;
}
this.children = [];
this.WorkAssignments = [];
this.Id = null;
this.WpId = null;
this.TaskId = null;
this.SubtaskId = null;
this.Type = null;
this.ItemNumber = null;
this.Name = null;
this.StartMonth = null;
this.StartDate = null;
this.EndMonth = null;
this.EndDate = null;
this.DurationInMonths = null;
this.DescriptionOfWork = null;
this.Objectives = null;
this.Percentage = null;
this.ClickUpListId = null;
this.ClickUpLink = null;
this.label = null;
this.ItemNumberInt = null;
this.Leader = null;
this.Participants = null;
this.TotalPersonMonthsBudgeted = null;
this.TotalParentEffort = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
WpId:any;
TaskId:any;
SubtaskId:any;
Type:any;
ItemNumber:any;
Name:any;
StartMonth:any;
StartDate:any;
EndMonth:any;
EndDate:any;
DurationInMonths:any;
DescriptionOfWork:any;
Objectives:any;
Percentage:any;
ClickUpListId:any;
ClickUpLink:any;
label:any;
ItemNumberInt:any;
Leader:any;
Participants:any;
TotalPersonMonthsBudgeted:any;
TotalParentEffort:any;
ParentItem:any;
children:any;
WorkAssignments:any;
static setParentItem = ($this, value) => {
var oldValue = $this.ParentItem;
$this.ParentItem = value;
if (value != null) {
if (oldValue != null) {
Domain.WorkplanItem.removechildren(oldValue, $this);
}
Domain.WorkplanItem.addchildren(value, $this);
}
}
static setchildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.children == null) $this.children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.children.length > 0) {
                    Domain.WorkplanItem.removechildren($this, $this.children[0]);
                }

                Domain.WorkplanItem.addManychildren($this, copyItems);
            }
static addManychildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.WorkplanItem.addchildren($this, items[i]);
                }
            }
static addchildren = ($this, item) => {
                if ($this.children == null) $this.children = [];
                if (item == null || $this.children.indexOf(item) > -1) return;
                $this.children.push(item);
if (item.ParentItem != $this) {
Domain.WorkplanItem.setParentItem(item, $this);
}
}
static addRangechildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.WorkplanItem.addchildren($this, item));
            }
static removechildren = ($this, item) => {
                if ($this == null || $this.children == null || $this.children.indexOf(item) === -1) return;
                var _index = $this.children.indexOf(item);
                $this.children.splice(_index, 1);
item.ParentItem = null;
}
static clearchildren = ($this) => { $this.children = null; }
static setWorkAssignments = ($this, items) => {
                if (items == null) items = [];
                if ($this.WorkAssignments == null) $this.WorkAssignments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.WorkAssignments.length > 0) {
                    Domain.WorkplanItem.removeWorkAssignments($this, $this.WorkAssignments[0]);
                }

                Domain.WorkplanItem.addManyWorkAssignments($this, copyItems);
            }
static addManyWorkAssignments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.WorkplanItem.addWorkAssignments($this, items[i]);
                }
            }
static addWorkAssignments = ($this, item) => {
                if ($this.WorkAssignments == null) $this.WorkAssignments = [];
                if (item == null || $this.WorkAssignments.indexOf(item) > -1) return;
                $this.WorkAssignments.push(item);
}
static addRangeWorkAssignments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.WorkplanItem.addWorkAssignments($this, item));
            }
static removeWorkAssignments = ($this, item) => {
                if ($this == null || $this.WorkAssignments == null || $this.WorkAssignments.indexOf(item) === -1) return;
                var _index = $this.WorkAssignments.indexOf(item);
                $this.WorkAssignments.splice(_index, 1);
}
static clearWorkAssignments = ($this) => { $this.WorkAssignments = null; }

static GetDueDate($this: any): any{let Time = Joove.Common.dateDiff(new Date(new Date($this?.EndDate)?.setHours(0, 0, 0, 0)), new Date(new Date(moment().toDate())?.setHours(0, 0, 0, 0)))?.days;
let result = "";
if (CLMS.Framework.Number.GreaterThan(() => Time, () => 30) && CLMS.Framework.Number.LessThan(() => Time, () => 365)) {Time = Joove.Common.safeNumber(Time) / Joove.Common.safeNumber(30);return Time?.toString() + " month(s) remaining";}else if (CLMS.Framework.Number.GreaterThanOrEqual(() => Time, () => 365)) {Time = Joove.Common.safeNumber(Time) / Joove.Common.safeNumber(365);return Time?.toString() + " year(s) remaining";}else if (CLMS.Framework.Number.GreaterThan(() => Time, () => 0)) {return Time?.toString() + " day(s) remaining";}else {return "Finished!";}
}
static GetDurationInMonths($this: any): any{return Joove.Common.safeNumber($this?.EndMonth) - Joove.Common.safeNumber($this?.StartMonth) + Joove.Common.safeNumber(1);
}
static IsActiveInProjectMonth($this: any, month: any): any{return CLMS.Framework.Number.LessThanOrEqual(() => $this.StartMonth, () => month) && CLMS.Framework.Number.GreaterThanOrEqual(() => $this.EndMonth, () => month);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}